
import NuxtImage from '~/components/Modules/Common/NuxtImage'

export default {
  components: { NuxtImage },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // showImg: false,
    }
  },
  watch: {
    showImg: {
      handler() {
        const tl = this.$gsap.timeline()
        tl.from(this.$refs.imgContainer, {
          scale: 0.6,
          duration: 0.7,
          autoAlpha: 0,
        })
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      // watch for svg img to be loaded
      this.$watch('$refs.img.element', () => {
        this.imgLoaded()
      })
      // this.imgLoaded()
    })
  },
  methods: {
    imgLoaded() {
      const mobile = this.$refs?.videoMobile
      const desktop = this.$refs?.videoDesktop

      if (mobile) {
        mobile.playbackRate = 0.5
      }

      if (desktop) {
        desktop.playbackRate = 0.5
      }

      this.$nextTick(() => {
        const tl = this.$gsap.timeline({ delay: 0.5 })
        tl.from(this.$refs.imgContainer, {
          scale: 0.6,
          duration: 0.7,
          autoAlpha: 0,
        })
      })
    },
  },
}
